import { tsValidateArray, tsValidateEnum, tsValidateString, tsValidateUniqueId } from '@nu-art/ts-common';
import { NavigationStatus } from './types.js';
import { AdvisorRuntimeIDBGroup, Validator_EncounterId } from '../../_core/index.js';
const Validator_ModifiableProps = {
    ...Validator_EncounterId,
    pathwayDbId: tsValidateUniqueId,
    pathwayKbVersion: tsValidateString(undefined, false),
    prevActiveStates: tsValidateArray(tsValidateUniqueId),
    activeState: tsValidateUniqueId,
    navigationStatus: tsValidateEnum(NavigationStatus)
};
const Validator_GeneratedProps = {};
export const DBDef_RuntimeActiveNavPathway = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'redis-active-nav-pathways',
    entityName: 'ActiveNavPathway',
    frontend: {
        group: AdvisorRuntimeIDBGroup,
        name: 'redis-active-nav-pathways'
    },
    backend: {
        name: 'redis-active-nav-pathways'
    }
};
//# sourceMappingURL=db-def.js.map